import store from '@/store'

/**
 * @param {Array} value
 * @returns {Boolean}
 * @example see @/views/permission/directive.vue
 */
export default function checkPermission(value) {
  if (value && value.length > 0) {
    const resourceList = store.getters && store.getters.resourceList
    const hasPermission = resourceList.some(item => {
      if (value instanceof Array) {
        return value.some(ele => ele === item.resourceCode)
      } else {
        return value === item.resourceCode
      }
    })
    return hasPermission
  } else {
    console.error(`need roles! Like v-permission="['admin','editor']"`)
    return false
  }
}
